import { CustomerGreenClassificationModel } from "../models/CustomerGreenClassificationModel";
import { client } from "./API";

const CustomerGreenClassificationService = {
  async getCustomerGreenClassifications() {
    const response = await client({
      url: "Customer/GetCustomerGreenClassifications",
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async createCustomerGreenClassification(
    data: CustomerGreenClassificationModel
  ) {
    try {
      const response = await client({
        method: "post",
        url: "Customer/PostCustomerGreenClassifications",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteCustomerGreenClassification(
    data: CustomerGreenClassificationModel
  ) {
    try {
      const response = await client({
        method: "delete",
        url: "Customer/DeleteCustomerGreenClassifications",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};
export default CustomerGreenClassificationService;
